import firebaseApp from '../firebase';
const db = firebaseApp.ref('/board_schedule');
import dayjs from 'dayjs';
import store from '../store';
export const FirebaseDataService = {
  getAll() {
    return db;
  },
  create(schedule) {
    return db.push(schedule);
  },
  update(key, value) {
    return db.child(key).update(value);
  },
  delete(key) {
    return db.child(key).remove();
  },
  deleteAll() {
    return db.remove();
  },
  async getOnce() {
    let FirebaseReceived = [];
    await db.once('value').then(function (dataSnapshot) {
      dataSnapshot.forEach(function (childSnapshot) {
        var key = childSnapshot.key;
        var data = childSnapshot.val();
        FirebaseReceived.push({
          key: key,
          board: data.board,
          strdate: data.strdate,
          enddate: data.enddate,
          strtime: data.strtime,
          endtime: data.endtime,
          description: data.description,
        });
      });
    });
    return FirebaseReceived;
  },
  async getOnceNow() {
    let nowsubtract = dayjs().subtract(7, 'day').format('YYYY-MM-DD');
    let now = dayjs().format('YYYY-MM-DD');
    //console.log(nowsubtract, now);
    let FirebaseReceived = [];
    await db
      .orderByChild('strdate')
      .startAt(nowsubtract)
      .endAt(now)
      .once('value')
      .then(function (dataSnapshot) {
        //console.log(dataSnapshot.val());
        dataSnapshot.forEach(function (childSnapshot) {
          var key = childSnapshot.key;
          var data = childSnapshot.val();
          FirebaseReceived.push({
            key: key,
            board: data.board,
            strdate: data.strdate,
            enddate: data.enddate,
            strtime: data.strtime,
            endtime: data.endtime,
            description: data.description,
          });
        });
      });
    //console.log('xxx : ', FirebaseReceived);
    return FirebaseReceived;
  },
  async getOnceSpacificDay(payload) {
    let nowsubtract = dayjs(payload)
      .subtract(7, 'day')
      .format('YYYY-MM-DD');
    let now = dayjs(payload).format('YYYY-MM-DD');
    //console.log(nowsubtract, now);
    let FirebaseReceived = [];
    await db
      .orderByChild('strdate')
      .startAt(nowsubtract)
      .endAt(now)
      .once('value')
      .then(function (dataSnapshot) {
        //console.log(dataSnapshot.val());
        dataSnapshot.forEach(function (childSnapshot) {
          var key = childSnapshot.key;
          var data = childSnapshot.val();
          FirebaseReceived.push({
            key: key,
            board: data.board,
            strdate: data.strdate,
            enddate: data.enddate,
            strtime: data.strtime,
            endtime: data.endtime,
            description: data.description,
          });
        });
      });
    //console.log('xxx : ', FirebaseReceived);
    return FirebaseReceived;
  },
  async getOnceMonth() {
    let strDateOfMonth = dayjs().date(1).format('YYYY-MM-DD');
    let nowsubtract = dayjs(strDateOfMonth)
      .subtract(7, 'day')
      .format('YYYY-MM-DD');
    let now = dayjs().date(31).format('YYYY-MM-DD');
    //console.log(nowsubtract, now);
    let FirebaseReceived = [];
    await db
      .orderByChild('strdate')
      .startAt(nowsubtract)
      .endAt(now)
      .once('value')
      .then(function (dataSnapshot) {
        //console.log(dataSnapshot.val());
        dataSnapshot.forEach(function (childSnapshot) {
          var key = childSnapshot.key;
          var data = childSnapshot.val();
          FirebaseReceived.push({
            key: key,
            board: data.board,
            strdate: data.strdate,
            enddate: data.enddate,
            strtime: data.strtime,
            endtime: data.endtime,
            description: data.description,
          });
        });
      });
    //console.log('xxx : ', FirebaseReceived);
    return FirebaseReceived;
  },
  async realtimeAwait() {
    db.on('value', () => {
      store.dispatch('dayScheduleLoad').then(() => {});
    });
  },
  async StopRealtimeAwait() {
    db.off('value');
  },
};
